import { render, staticRenderFns } from "./s-vr.vue?vue&type=template&id=4923cc71&scoped=true&"
import script from "./s-vr.vue?vue&type=script&lang=js&"
export * from "./s-vr.vue?vue&type=script&lang=js&"
import style0 from "./s-vr.vue?vue&type=style&index=0&id=4923cc71&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4923cc71",
  null
  
)

export default component.exports